module.exports = __webpack_public_path__ + "static/media/logo.090c06a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo.svg
// module id = 57
// module chunks = 0